import './ServiceRequestManageDelegate.css';

import 'flatpickr/dist/themes/light.css';
import CardViewComponent from '../../../lib/CardViewComponent/CardViewComponent';
import Datepicker from '../../../lib/Datepicker/Datepicker';
import InputWidget from '../../../lib/InputWidget/InputWidget';
import SelectWidget from '../../../lib/SelectWidget/SelectWidget';
import {
  getAuthorizedUserDetailsAction,
  getServiceRequestDetailsAction,
  pushViewAction,
} from '../../../redux/actions/Actions';
import {appStore} from '../../../redux/createStore';
import {getAPICall} from '../../../services/apiCallsHandler';
import {
  emailRegex,
  nifPortugalRegex,
  PORTUGAL_COUNTRY_CODE,
  SPAIN_COUNTRY_CODE,
} from '../../../utils/constant';
import Smartlook from '../../../utils/smartlook';
import {
  getLocalDatePickerFile,
  replaceTranslations,
  sanitizeInput,
  serviceRequestPostCall,
} from '../../../utils/util';
import CurrentlyUnavailableCard from '../../currently_unavailable_div/CurrentlyUnavailableCard';
import SkeletonLoader from '../../skeletonLoader/SkeletonLoader';

import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Radio,
  RadioGroup,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useToastProvider,
} from '@deere/fuel-react';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import Divider from '@mui/material/Divider';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {connect} from 'react-redux';

const ServiceRequestManageDelegate = (props) => {
  const {t} = useTranslation();
  const {enqueueToast} = useToastProvider();
  const [submitDisabled, setSubmitDisabled] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const [loader, setLoader] = React.useState(false);

  const [manageUserType, setManageUserType] = React.useState('Add Delegate');

  const [firstName, setFirstName] = React.useState('');
  const [lastName, setLastName] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [bankMandateCheck, setBankMandateCheck] = React.useState(false);
  const [nationalId, setNationalId] = React.useState('');
  const [birthDate, setBirthDate] = React.useState('');

  const [userName, setUserName] = React.useState();
  const [userNameOptions, setUserNameOptions] = React.useState([]);
  const [displayUnavailableCard, setDisplayUnavailableCard] =
    React.useState(false);
  const [selectedUser, setSelectedUser] = React.useState(null);

  React.useEffect(() => {
    if (props.authorizedUserDetails) {
      setUserNameOptions(
        props.authorizedUserDetails
          ?.filter(
            (item) => item.name !== props.userName && item.isDelegate === true
          )
          ?.map((user) => ({
            label: user.name,
            value: user.name,
            email: user.userEmail,
            secondaryCustomerId: user.customerId,
          }))
      );
    }
  }, [props.authorizedUserDetails]);

  React.useEffect(() => {
    setIsLoading(true);
    Smartlook.navigation('ServiceRequestManageDelegate');
    getAPICall(
      `myAccount`,
      {
        isCallBack: false,
        errorTag: 'GET_MYACCOUNT_DETAIL',
        redirectToOops: false,
      },
      {
        stateName: 'authorizedUserDetails',
        actionName: getAuthorizedUserDetailsAction,
      }
    ).then((response) => {
      if (response.isError) {
        setIsLoading(false);
        setDisplayUnavailableCard(true);
      } else {
        setIsLoading(false);
      }
    });
  }, []);

  React.useEffect(() => {
    const isFormValid =
      firstName &&
      firstName.length > 0 &&
      lastName.length > 0 &&
      birthDate.length > 0 &&
      emailRegex.test(email) &&
      (props.country === SPAIN_COUNTRY_CODE
        ? nationalId && nationalId.length > 0
        : props.country === PORTUGAL_COUNTRY_CODE
        ? nationalId && nifPortugalRegex.test(nationalId)
        : true);

    setSubmitDisabled(!isFormValid);
  }, [firstName, lastName, email, birthDate, nationalId, props.country]);

  React.useEffect(() => {
    if (userName && userName.length > 0) {
      setSubmitDisabled(false);
    } else {
      setSubmitDisabled(true);
    }
  }, [userName]);

  const handleUserSelect = (selectedValue) => {
    const foundUser = userNameOptions.find((u) => u.value === selectedValue);
    setUserName(selectedValue);
    setSelectedUser(foundUser);
  };

  const handleFirstName = async (value) => {
    const sanitizedInput = await sanitizeInput(value);
    setFirstName(sanitizedInput);
  };

  const handleLastName = async (value) => {
    const sanitizedInput = await sanitizeInput(value);
    setLastName(sanitizedInput);
  };

  const handleEmail = (value) => {
    setEmail(value.trim());
  };

  const handleNationalId = async (value) => {
    const sanitizedInput = await sanitizeInput(value);
    setNationalId(sanitizedInput);
  };

  const handleDateChange = (e) => {
    setBirthDate(moment(e[0]).format('YYYY-MM-DD'));
  };

  const formButtonControls = () => {
    return (
      <div className="buttonControls">
        <Button
          id="cancelButton"
          onClick={() => props.cancelButtonClick(null)}
          variant="secondary"
        >
          {t('CANCEL')}
        </Button>

        <Button
          type="submit"
          disabled={submitDisabled}
          id="DelegatePrimaryBtn"
          variant="primary"
          startIcon={
            loader && <CircularProgress size="small" style={{color: '#000'}} />
          }
        >
          {t('SUBMIT')}
        </Button>
      </div>
    );
  };

  const delegateSubmitHandler = (e) => {
    const reqBody = {};
    reqBody.manageUserType = manageUserType;
    reqBody.contractNumber = props.contractNumber;
    reqBody.countryCode = props.country;
    if (props.selectedParty) {
      reqBody.party = props.selectedParty;
    }
    if (manageUserType == 'Add Delegate') {
      reqBody.firstName = firstName;
      reqBody.lastName = lastName;
      reqBody.email = email;
      reqBody.bankMandateCheck = bankMandateCheck;
      reqBody.birthDate = birthDate;
      if (
        props.country === SPAIN_COUNTRY_CODE ||
        props.country === PORTUGAL_COUNTRY_CODE
      ) {
        reqBody.nationalId = nationalId;
      }
    }

    if (manageUserType == 'Remove Delegate') {
      reqBody.userName = userName;
      reqBody.delegateEmail = selectedUser?.email;
      reqBody.secondaryCustomerId = selectedUser?.secondaryCustomerId;
    }

    e.preventDefault();
    setSubmitDisabled(true);
    setLoader(true);
    const successMessage =
      manageUserType === 'Remove Delegate'
        ? t('REMOVE_DELEGATE_REQUEST_SUCCESS')
        : t('DELEGATE_REQUEST_SUCCESS');
    serviceRequestPostCall(
      {
        requestType: 'Manage Delegate',
        countryCode: props.country,
        userEmail: props.userDetails.email,
        ...reqBody,
      },
      enqueueToast,
      'DELEGATE_USER_MANAGE_SERVICE_REQUEST',
      () => {
        setLoader(false);
        setSubmitDisabled(false);
      },
      replaceTranslations(t('SERVICE_REQUEST_LIMIT'), 50, t('MANAGE_DELEGATE')),
      successMessage,
      t('DELEGATE_REQUEST_FAILURE'),
      () => {
        appStore.dispatch(getServiceRequestDetailsAction(null));
        appStore.dispatch(pushViewAction('serviceRequestDashboard'));
      }
    );
  };

  let helperTextEmail = null;
  if (email?.trim()?.length <= 0) {
    helperTextEmail = 'FAQ_MODAL_ERROR';
  } else if (!emailRegex.test(email)) {
    helperTextEmail = 'FAQ_MODAL_EMAIL_ERROR';
  }

  const monthYearPickerOptions = {
    maxDate: new Date(),
    dateFormat: 'Y-m-d',
    locale: getLocalDatePickerFile(),
    disableMobile: true,
  };

  const renderCurrentlyUnavailableComponent = () => {
    return (
      <CurrentlyUnavailableCard
        title={t('SOMETHING_WENT_WRONG')}
        subTitle={t('SERV_DASHBOARD_NOT_AVAILABLE')}
        fullScreen={true}
      />
    );
  };

  const delegateFormFields = [
    {
      label: 'DELEGATE_FIRST_NAME',
      type: 'text',
      required: true,
      id: 'delegate-first-name',
      value: firstName,
      setValue: handleFirstName,
      error: firstName.length > 0,
      helperText: 'FAQ_MODAL_ERROR',
    },
    {
      label: 'DELEGATE_LAST_NAME',
      type: 'text',
      required: true,
      id: 'delegate-last-name',
      value: lastName,
      setValue: handleLastName,
      error: lastName.length > 0,
      helperText: 'FAQ_MODAL_ERROR',
    },
    {
      label: 'DELEGATE_EMAIL',
      type: 'text',
      required: true,
      id: 'delegate-email',
      value: email,
      setValue: handleEmail,
      error: emailRegex.test(email),
      helperText: helperTextEmail,
    },
  ];

  if (
    props.country === SPAIN_COUNTRY_CODE ||
    props.country === PORTUGAL_COUNTRY_CODE
  ) {
    const handleNationalIdSync = (value) => {
      handleNationalId(value);
    };
    delegateFormFields.push({
      label: 'DELEGATE_NATIONAL_ID',
      type: 'text',
      required: true,
      id: 'delegate-national-id',
      value: nationalId,
      setValue: handleNationalIdSync,
      error: nationalId.length > 0,
      helperText: 'FAQ_MODAL_ERROR',
    });
  }

  let content;
  if (isLoading) {
    content = <SkeletonLoader componentName="ServiceRequestDashboard" />;
  } else if (displayUnavailableCard) {
    content = renderCurrentlyUnavailableComponent();
  } else {
    content = (
      <div className={'ServiceRequestChangePhoneWrapper'}>
        <div className={'ServiceRequestCard'}>
          <div className="serviceRequestHeader">
            <div className={'title'}>{t('DELEGATE_USER_REQUEST')}</div>
          </div>
          <div className={'subTitle'}>
            {t('DELEGATE_USER_REQUEST_SUBTITLE')}
          </div>
        </div>
        <Box pl={4} pr={4} pb={4}>
          <form onSubmit={delegateSubmitHandler}>
            <Typography gutterBottom variant="h5" required={true}>
              {t('DELEGATE_USER_CHOOSE_OPTION')}
              <span className="datepicker-asterisk">*</span>
            </Typography>
            <RadioGroup
              name="group1"
              data-testid="radio-button-id"
              className="DelegateTypeRadioGroup"
              defaultValue={manageUserType}
              onClick={(e) => setManageUserType(e.target.value)}
            >
              <FormControlLabel
                control={<Radio />}
                label={t('DELEGATE_USER_ADD')}
                value="Add Delegate"
              />
              {props.authorizedUserDetails &&
              props.authorizedUserDetails.length > 0 &&
              userNameOptions.length > 0 ? (
                <FormControlLabel
                  control={<Radio />}
                  label={t('DELEGATE_USER_REMOVE')}
                  value="Remove Delegate"
                />
              ) : null}
            </RadioGroup>

            {manageUserType === 'Remove Delegate' && (
              <Card className="AuthorizedUserCardCustom RemoveCardContainer">
                <CardContent className="DelegateUserCard">
                  <div className="DelegateUserAddressSection">
                    <div className={'ServiceRequestCard'}>
                      <div className="serviceRequestHeader">
                        <div className={'title'}>
                          {t('REMOVE_EXISTING_DELEGATE_TITLE')}
                        </div>
                      </div>
                      <div className={'subTitle'}>
                        {t('REMOVE_EXISTING_DELEGATE_SUB_TITLE')}
                      </div>
                    </div>
                    <div className="AuthorizedUserContainer">
                      <div className="AuthorizedUserReasonWrapper">
                        <SelectWidget
                          label={t('DELEGATE_USER_NAME')}
                          id="DelegateUser-reason"
                          changeHandler={handleUserSelect}
                          data={userNameOptions}
                          defaultValue={userName}
                          value={userName}
                          required={true}
                          className={'reasonType'}
                          helperText={t('DELEGATE_USER_NAME_HELPERTEXT')}
                        />
                      </div>
                    </div>
                    <div className="AuthorizedUserEmailWrapper DelegateCardView">
                      {selectedUser && (
                        <CardViewComponent
                          key={'card-component' + selectedUser.label}
                          records={{
                            DELEGATE_NAME: {
                              label: t('DELEGATE_NAME'),
                              value: selectedUser.label,
                            },
                            DELEGATE_EMAIL_ID: {
                              label: t('DELEGATE_EMAIL_ID'),
                              value: selectedUser.email,
                            },
                          }}
                        />
                      )}
                    </div>
                  </div>
                </CardContent>
              </Card>
            )}

            {manageUserType === 'Add Delegate' && (
              <Card className="DelegateCardCustom">
                <CardContent className="DelegateCard">
                  <div className="DelegateAddressSection">
                    <div className={'ServiceRequestCard'}>
                      <div className="serviceRequestHeader">
                        <div className={'title'}>
                          {t('ADD_NEW_USER_DELEGATE')}
                        </div>
                      </div>
                      <div className={'subTitle'}>
                        {t('ADD_NEW_USER_SUBTITLE_DELEGATE')}
                      </div>
                    </div>
                    <div className="DelegateContainer">
                      {delegateFormFields.map((i, index) => (
                        <InputWidget
                          key={i.id}
                          required={i.required}
                          type={i.type}
                          id={i.id}
                          label={t(i.label)}
                          value={i.value}
                          setValue={i.setValue}
                          customError={true}
                          error={i.error}
                          helperText={t(i.helperText)}
                          multiline={i.multiline}
                          minRows={i.minRows}
                        />
                      ))}
                      <div id="settlement-datepicker">
                        <Typography gutterBottom variant="h5" required={true}>
                          {t('DELEGATE_BIRTH_DATE')}{' '}
                          <span className="datepicker-asterisk">*</span>
                        </Typography>
                        <div style={{position: 'relative', width: '100%'}}>
                          <Datepicker
                            placeholder={'YYYY-MM-DD'}
                            isRequired={true}
                            setDate={(e) => handleDateChange(e)}
                            options={monthYearPickerOptions}
                            value={birthDate}
                            style={{width: '100%', paddingRight: 36}}
                          />
                          <CalendarMonthIcon
                            style={{
                              position: 'absolute',
                              right: 10,
                              top: '50%',
                              transform: 'translateY(-50%)',
                              color: '#757575',
                              pointerEvents: 'none',
                            }}
                          />
                        </div>
                      </div>
                    </div>

                    <Divider className="DelegateDivider" variant="middle" />

                    <Alert title="" variant="info" id="delegate-info-notice">
                      <ol>
                        <li>{t('DELEGATE_ACCESS_DESCRIPTION')}</li>
                        <li>{t('DELEGATE_RESTRICTIONS_DESCRIPTION')}</li>
                        <li>{t('DELEGATE_FUTURE_PERMISSIONS_DISCLAIMER')}</li>
                      </ol>
                    </Alert>

                    <TableContainer data-fuel-outlined={true}>
                      <Table aria-label="simple table">
                        <TableHead>
                          <TableRow>
                            <TableCell>
                              {t('SELECT_MODULE_FOR_ACCESS')}
                              <span className="datepicker-asterisk">*</span>
                            </TableCell>
                            <TableCell></TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          <TableRow>
                            <TableCell>{t('CHECK_BANK_MANDATE')}</TableCell>
                            <TableCell align="right">
                              <FormControlLabel
                                control={
                                  <Switch
                                    data-fuel-hide-icons={true}
                                    data-fuel-hide-on-icon={true}
                                    data-fuel-hide-off-icon={true}
                                    checked={bankMandateCheck}
                                    onChange={(event) =>
                                      setBankMandateCheck(event.target.checked)
                                    }
                                  />
                                }
                                label=""
                              />
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </div>
                </CardContent>
              </Card>
            )}

            {formButtonControls()}
          </form>
        </Box>
      </div>
    );
  }

  return (
    <div>
      <Box>
        <div>{content}</div>
      </Box>
    </div>
  );
};

export const mapStateToProps = (state) => {
  return {
    userDetails: state.appStates.userDetailsInfo,
    country: state.appStates.allContracts?.countryCode,
    authorizedUserDetails: state.appStates.authorizedUserDetails,
    userName: state.appStates.allContracts?.userName,
  };
};
ServiceRequestManageDelegate.propTypes = {
  cancelButtonClick: PropTypes.func,
  contractNumber: PropTypes.string,
  country: PropTypes.string,
  selectedParty: PropTypes.any,
  userDetails: PropTypes.object,
  authorizedUserDetails: PropTypes.array,
  userName: PropTypes.string,
};

export default connect(mapStateToProps)(ServiceRequestManageDelegate);
